import { Divider } from "@material-ui/core"
import React from "react"

function PanelHeader(props){

    const {title, value} = props;

    return(
        <div>
            <div style={{padding: "0.5rem 1rem 0.5rem"}}><span style={{fontWeight: 700, marginRight: "0.25rem"}}>{title}</span>{value}</div>
            <Divider style={{width: "100%"}}/>
        </div>  
    )
}

export {PanelHeader}